
export const environment = {
    production: false,
    title: 'E-Art',
};
